import * as React from 'react';

export const ArrowUp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 10 10" {...props}>
    <path
      fill="currentColor"
      d="M8.18106781 7.29619408 4.9990873 4.11421356 1.81710678 7.29619408 1.11 6.5890873 4.9990873 2.7 8.88817459 6.5890873z"
    />
  </svg>
);
